import { Box, TextField } from '@mui/material';

export interface PickerShortcutItem<TValue> {
  label: string;
  getValue: (params: { isValid: (value: TValue) => boolean }) => TValue;
}

interface PickerShortcutsSelectProps<TValue> {
  items?: PickerShortcutItem<TValue>[];
  onSelect: (item: PickerShortcutItem<TValue>) => void;
  placeholder: string;
  selectedLabel?: string;
}

export default function PickerShortcutsSelect<TValue>({
  items,
  onSelect,
  placeholder,
  selectedLabel,
}: PickerShortcutsSelectProps<TValue>) {
  if (!items?.length) {
    return null;
  }

  return (
    <Box
      sx={{
        gridColumn: '1 / -1',
        gridRow: 1,
        px: 2,
        pb: 1,
        pt: 1,
        width: '100%',
      }}
    >
      <TextField
        select
        fullWidth
        size='small'
        value={selectedLabel ?? ''}
        onChange={(event) => {
          const selectedItem = items.find(
            (item) => item.label === event.target.value,
          );

          if (selectedItem) {
            onSelect(selectedItem);
          }
        }}
        SelectProps={{ native: true }}
        inputProps={{ 'aria-label': placeholder }}
      >
        <option
          disabled
          value=''
        >
          {placeholder}
        </option>
        {items.map((item) => (
          <option
            key={item.label}
            value={item.label}
          >
            {item.label}
          </option>
        ))}
      </TextField>
    </Box>
  );
}
